module.exports = {
  CLICK: 'click',
  CUSTOM: 'custom',
  ENGAGEMENT: 'engagement',
  PAGEVIEW: 'pageview',
};
